import UsersGrid from '../components/Grid';
import { UserProvider } from '../store';

export default function UsersGridLayout() {
  return <UserProvider>
    <UsersGrid />
  </UserProvider>;
}
